import Avatar from "@mui/material/Avatar";
type CustomImageAvatarType = {
  avatarSource: string;
  altText: string;
};
const CustomImageAvatar = ({
  avatarSource,
  altText,
}: CustomImageAvatarType) => {
  return <Avatar alt={altText} src={avatarSource} />;
};
export default CustomImageAvatar;
